export default "__VITE_ASSET__LNweg0ls__"